import { usePortalData } from '../data/usePortalData';
import { useTicket } from '../data/useTicket';
import { renderPropertyValue } from './formatCell';
import { useTicketDetailsParams } from '../hooks/useTicketDetailsParams';
export const useDetailsConfiguredTicketProperty = accessor => {
  var _ref;
  const {
    ticketId
  } = useTicketDetailsParams();
  const {
    data: ticket
  } = useTicket(ticketId);
  const {
    data: {
      configuredTicketDetailProperties
    } = {}
  } = usePortalData();
  const configuredProperty = configuredTicketDetailProperties === null || configuredTicketDetailProperties === void 0 ? void 0 : configuredTicketDetailProperties.find(({
    propertyName
  }) => propertyName === accessor);
  const {
    displayNameOverride: propertyDisplayName
  } = configuredProperty !== null && configuredProperty !== void 0 ? configuredProperty : {};
  const propertyValue = (_ref = ticket === null || ticket === void 0 ? void 0 : ticket[accessor]) !== null && _ref !== void 0 ? _ref : null;
  const formattedPropertyValue = configuredProperty ? renderPropertyValue(propertyValue, configuredProperty) : null;
  return {
    propertyDisplayName,
    propertyValue,
    formattedPropertyValue
  };
};